module.exports = __webpack_public_path__ + "img/house_plan01.32de0641.svg";